import React from 'react';

import '../../assets/styles/Shimmer.css';

const ContactShimmer = () => (
    <div>
        <p className="skeleton-box" style={{ height: '22px', width: '90%' }} />
        <p className="skeleton-box" style={{ height: '22px', width: '90%' }} />
        <p className="skeleton-box" style={{ height: '22px', width: '90%' }} />
        <p className="skeleton-box" style={{ height: '22px', width: '90%' }} />
    </div>
);

export default ContactShimmer;
